@let order = order$();
@let options = options$();

<div class="order-summary-header-wrapper">
	<div class="company-info">
		<div class="company-logo" i18n="@@OrderSummaryHeaderCompanyLogo">
			<img
				loading="lazy"
				src="assets/images/logo/GRANO_LOGO_BLACK_RGB.webp"
				width="150"
				i18n-alt="@@OrderSummaryHeaderLogoAlt"
				alt="Logo"
			/>
		</div>
		<div class="company-details">
			<div i18n="@@OrderSummaryHeaderCompanyName">Grano Oy</div>
			<div i18n="@@OrderSummaryHeaderCompanyAddress">Piitie 3, 01510 Vantaa</div>
			<div i18n="@@OrderSummaryHeaderCompanyBusinessId">Y-tunnus: 2197935-0</div>
			<div i18n="@@OrderSummaryHeaderCompanyVatNumber">VAT: FI21979350</div>
		</div>
	</div>
	@if (isCheckoutV2) {
		<header class="order-summary-header">
			<h1 i18n="@@OrderConfirmationThankYouHeader">Thank you for your order!</h1>
			<p i18n="@@OrderConfirmationEmailText">Confirmation email has been sent</p>
			<p>
				<strong i18n="@@OrderConfirmationOrderNumberHeader">Order number</strong>:
				{{ order.order_number }}
			</p>
			<p>
				<strong i18n="@@OrderConfirmationOrderDateHeader">Order date</strong>:
				{{ order.created_at | date: 'dd.MM.yyyy HH:mm' }}
			</p>
		</header>
	} @else {
		<header class="legacy-view">
			<h2 i18n="@@OrderSummaryHeaderOrderTitle">Order</h2>
			<h2 data-cy="orderNumber">#{{ order.order_number }}</h2>
			<div i18n="@@OrderSummaryHeaderOrderDate"
				>Order date: <span>{{ order.created_at | date: 'd.M.y' }}</span></div
			>
			<div>
				<span i18n="@@OrderSummaryHeaderReceiptNumber">Receipt number</span>:
				<span>{{ order.order_number }}</span>
			</div>
			<div>
				@if (options?.shouldShowOrderStatus && order.status?.order; as status) {
					<span class="status">
						<span i18n="@@OrderSummaryHeaderOrderStatus">Order status</span>:

						<g-order-status-switch [orderStatus]="status" />
					</span>
				}
			</div>
		</header>
	}
	<div class="qr-code-section">
		@if (qrCodeDataUrl$()) {
			<img
				[src]="qrCodeDataUrl$()"
				i18n-alt="@@OrderSummaryHeaderQrCodeAlt"
				alt="QR code for order details"
				class="qr-code-image"
			/>
			<p i18n="@@OrderSummaryHeaderQrCodeLabel">Scan for order details</p>
		}
	</div>
</div>
